


//react
import './App.css';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { useRef, useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer.jsx';

//pages
import Dashboard from './pages/Dashboard.jsx';
import Home from './pages/Home.jsx';
import Services from './pages/Services.jsx'
import Responsibilities from './pages/Responsibilities.jsx';
import Highlights from './pages/Highlights.jsx';
import PageNotFound from './pages/PageNotFound.jsx';
import TimestampGenerator from './pages/TimestampGenerator.jsx';
import Beta from './pages/Beta.jsx';
import Legal from './pages/Legal.jsx';
import Deployments from './pages/QmcApprovedEvents.jsx';
import Newbies from './pages/Newbies.jsx';
import Login from './pages/Login.jsx';
import ApplicationCenter from './pages/ApplicationCenter.jsx'
import HallOfFame from './pages/HallOfFame.jsx';

//test pages
import TimestampGeneratorTest from './Test/TimestampGenerator.jsx';

//assets
import packageJSON from '../package.json'
import Message from './components/Message.jsx';

//utils
import serverObject from "./config.js"


function App() {
  const [toastMessage, setToastMessage] = useState('');
  const toastRef = useRef(null);
  const showToast = (text) => {
    setToastMessage(`${text}`);
    if (toastRef.current) {
        const toast = window.bootstrap.Toast.getOrCreateInstance(toastRef.current);
        toast.show();
    }
  }
  return (
    <>
      <Router basename={packageJSON.prefix}>
        <div className="App">
          <Navbar />
          <div className='content'>
            <Switch>
              <Route path="/Dashboard" exact>
                <Dashboard />
              </Route>
              <Route path="/" exact>
                <Home />
              </Route>
              <Route path="/Services" exact>
                <Services />
              </Route>
              <Route path="/Responsibilities" exact>
                <Responsibilities />
              </Route>
              <Route path="/Highlights" exact>
                <Highlights />
              </Route>
              <Route path="/Timestamp" exact>
                <TimestampGenerator showToast={showToast} />
              </Route>
              <Route path="/TimestampGenerator" exact>
                <TimestampGenerator showToast={showToast} />
              </Route>
              <Route path="/Beta" exact>  
                <Beta />
              </Route>
              <Route path="/Beta/TimestampGenerator" exact>  
                <TimestampGeneratorTest />
              </Route>
              <Route path="/Legal" exact>  
                <Legal />
                
              </Route>
              <Route path="/Deployments" exact>  
                <Deployments showToast={showToast} />
              </Route>
              <Route path="/Newbies" exact>  
                <Newbies />
              </Route>
              <Route path="/Login" exact>  
                <Login />
              </Route>
              <Route path="/ApplicationCenter/" exact>  
                <ApplicationCenter />
              </Route>
              <Route path="/ApplicationCenter/:applicationId" exact>  
                <ApplicationCenter />
              </Route>
              <Route path="/HallOfFame" exact>
                <HallOfFame />
              </Route>
              


              <Route path="*" exact>
                <PageNotFound />
              </Route>
              
            </Switch>
    
          </div>
          <br />
          <Footer />
        </div>
      </Router>
    <Message id="liveToast" message={toastMessage} ref={toastRef} />
    </>
  );
}

export default App;
